import { Button, Menu } from "@mui/material";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";
import { IconEmail } from "Components/Generic/Icons/IconEmail";

export const Steps = styled("div")(() => ({
  "@media screen and (min-width: 860px)": {
    display: "none",
  },
}));

export const TextWrapper = styled("div")(() => ({
  display: "inline-block",
  "@media screen and (max-width: 768px)": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 2,

    padding: "12px 0",
  },
}));

interface HeaderTextProps {
  small?: boolean;
  withSpace?: boolean;
}
export const HeaderRightText = styled("span")(
  ({ small = false, withSpace = false }: HeaderTextProps) => ({
    font: "700 16px/24px Manrope",
    color: colors.gray800,
    letterSpacing: 0.5,
    marginRight: withSpace ? 4 : 0,

    "@media screen and (max-width: 768px)": {
      fontSize: small ? 12 : 16,
      fontWeight: small ? 600 : 700,
      color: small ? colors.gray400 : colors.gray800,
      marginRight: 0,
    },
  })
);

export const PageWrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "flex",
  flexDirection: "column",
  minHeight: "100dvh",
}));

export const PageMain = styled("main")(() => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  flex: 1,
}));

export const PageMainContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  marginLeft: "auto",
  marginRight: "auto",
  maxWidth: 1440,
  width: "100%",
  zIndex: 1000,
  flex: 1,

  "& > *": {
    flex: 1,
  },
}));

export const ContainerBadgeStatus = styled("div")(() => ({
  cursor: "pointer",
}));

export const Divider = styled("div")(() => ({
  backgroundColor: "#E4E7EC",
  height: "1px",
  margin: "8px 0px",
}));

export const ButtonOrders = styled("div")(({ open = false }: { open?: boolean }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "8px",
  borderRadius: "8px",
  cursor: "pointer",
  width: "36px",
  height: "36px",

  "@media screen and (min-width: 769px)": {
    [open ? "backgroundColor" : ""]: "#6670851F",
    "&:hover": {
      backgroundColor: "#6670851F",
    },
  },

  "@media screen and (max-width: 768px)": {
    padding: 0,
    paddingTop: 3,
  },
}));

export const ButtonEscalation = styled(Button)(() => ({
  padding: "10px 12px",
  font: "600 14px Manrope",
  letterSpacing: "0.1px",
  lineHeight: "20px",
  textTransform: "none",
  color: colors.gray600,
  gap: "8px",

  "@media screen and (max-width: 475px)": {
    display: "none",
  },
}));

export const StyledMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    borderRadius: "12px",
    boxShadow: "0px 4px 10px rgba(15, 56, 104, 0.25)",
    minWidth: "180px",
    "& .MuiMenu-list": {
      fontSize: 18,
    },
    "& .MuiMenuItem-root": {
      padding: "8px 16px",
      fontFamily: "Manrope !important",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: "#475467",
      justifyContent: "space-between",
    },
    "& .MuiMenuItem-root.Mui-selected": {
      backgroundColor: "#0055A414",
    },
    "& .MuiMenuItem-root:hover": {
      backgroundColor: "#0055A414",
    },
  },
}));

export const BadgeRequestEscalation = styled("div")(() => ({
  position: "absolute",
  top: "4px",
  right: "4px",
  borderRadius: "100px",
  backgroundColor: "#f04438",
  height: "6px",
  width: "6px",
}));

export const WrapperBadge = styled("div")(() => ({
  position: "absolute",
  marginBottom: "40px",
  marginLeft: "40px",
}));

export const ContactIcon = styled(IconEmail)(() => ({}));

const status = makeStyles(() => ({
  uiTab: {
    height: "100% !important",
  },
  tabDetails: {
    padding: "1.5rem",
    border: "none",
    "@media screen and (max-width: 425px)": {
      padding: "16px 0 !important",
    },
  },
  tabInventory: {
    padding: 0,
    border: "none",
    backgroundColor: "transparent",
  },
  tabShipments: {
    padding: "0 !important",

    "@media screen and (max-width: 435px)": {
      padding: "0.75rem !important",
    },
  },
  mt40: {
    marginTop: 40,
  },
  wrapperTemplate: {
    padding: "12px 16px",
    height: "calc(100vh - 168px)",
    "& span": {
      font: "500 20px/28px Manrope",
      color: "#465869",
    },
    "& h3": {
      font: "700 24px/33px Manrope",
      color: "#465869",
    },
  },
  sendToReviewButton: {
    font: "700 14px/24px Inter",
    width: 156,
  },
  modalContent: {
    font: "400 16px/24px Inter",
    color: "#232325",
  },
  titlePage: {
    width: "100%",
  },
  badgeDocumentsMissing: {
    backgroundColor: "#F04438 !important",
    padding: "0px !important",
    width: "16px !important",
    height: "16px !important",
  },
  paperMenu: {
    marginTop: "7px",
    width: 320,
    minHeight: "200px",
  },
  badge: {
    height: 24,
    maxWidth: 148,
    borderRadius: 100,
    padding: "4px 12px",
    "& > span": {
      fontFamily: "Manrope",
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "16px",
      letterSpacing: 0.5,
    },
  },
  skeleton: {
    height: "382px",
    width: "100%",
    borderRadius: "12px !important",
  },
  contactUsLoading: {
    minWidth: "123px",
    height: "40px",
  },
  orderSelectionLoading: {
    maxWidth: "320px",
    "&.MuiSkeleton-text": {
      marginBottom: "16px",
    },
  },
}));

export default status;
